import $ from 'gridstrap/lib/gs-zepto';
import { modal } from '.';

export class GSModal {

	//
	// Properties
	//

	private root;
	private document;
	private closeButtons;
	private contents;
	private forms;

	get isDismissable() { return this.root.hasClass('gs-Modal--dismissable'); }
	get currentField()  { return this.root.find('input:focus, textarea:focus'); }
	get maxWidth()      { return this.root.data('gsModalMaxWidth') || 800; }
	set isOpen(val)     { this.root.addClass(val ? 'is-open' : 'is-closing'); }

	//
	// Methods
	//

	close() {
		if (!this.isOkayToClose()) return false;

		setTimeout(() => {
			this.root.one('transitionend', evt => this.remove());
			this.isOpen = false;
		}, 200);
	}

	private isOkayToClose() {
		let isDirty = this.forms.not('.is-processing').gs('isDirty').includes(true);
		let message = 'Are you sure you want to close this form? Your information will not be saved.';
		return isDirty ? confirm(message) : true;
	}

	private remove() {
		const modalId = modal.modalId;
		modal.cleanup();
		document.dispatchEvent(new CustomEvent('gs:modalClose', { detail: { modalId } }));
		this.root.remove();
	}

	//
	// Initializations and Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.document = $(document);
		this.contents = this.root.find('.gs-Modal-contents');
		this.forms = this.root.find('.gs-Form');
		this.closeButtons = this.root.find('[role~="close"]');

		this.document.on('keydown.modal', evt => this.handleKeydown(evt));
		this.closeButtons.on('click', evt => modal.close());

		this.contents.css('max-width', this.maxWidth);

		setTimeout(() => {
			this.isOpen = true;
			this.document.trigger('resize');
		}, 50);
	}

	gsOnDestroy() {
		this.document.off('keydown.modal');
		this.closeButtons.off('click');
	}

	private handleKeydown(evt) {
		if (this.currentField.length > 0) return;
		if (!this.isDismissable) return;

		if (evt.which == 27) {
			evt.preventDefault(); // Don't exit fullscreen mode
			this.close();
		}
	}
}
